module.exports = __webpack_public_path__ + "static/media/offersIcon.9a99a345.svg";